import style from "./style.module.css";

export default function PionexLogo() {
    return (
        <div className={style.logoBox}>
            <img className={style.logoIcon} src={require("../../images/logo_white.png")} alt="" />
        </div>
    );
}
